import * as React from 'react'

import { ContentEpisodeRow as Presenter, IProps } from './presenter'
export { SUPPORT_TYPE_PINK, SUPPORT_TYPE_BLUE } from './presenter'

export const ContentEpisodeRow = ({
  lastEpisode,
  supportType,
  supporterName,
  pcEpisode,
  pcDevelopmentBefore,
  pcDevelopmentAfterTop,
  pcDevelopmentAfterBottom,
  spEpisode,
  spDevelopmentBefore,
  spDevelopmentAfterTop,
  spDevelopmentAfterBottom,
  colorButtonAccordionTitle1,
  colorButtonAccordionTitle2,
  colorButtonHref,
  linkButtonAccordionTitle1,
  linkButtonAccordionTitle2,
  linkButtonHref,
  ...props
}: Omit<IProps, 'accordionOpen' | 'episodeClickHandler'>): JSX.Element => {
  const [accordionOpen, setAccordionOpen] = React.useState<boolean>(false)

  const episodeClickHandler = () => {
    setAccordionOpen(true)
  }
  return (
    <Presenter
      lastEpisode={lastEpisode}
      supportType={supportType}
      supporterName={supporterName}
      pcEpisode={pcEpisode}
      pcDevelopmentBefore={pcDevelopmentBefore}
      pcDevelopmentAfterTop={pcDevelopmentAfterTop}
      pcDevelopmentAfterBottom={pcDevelopmentAfterBottom}
      spEpisode={spEpisode}
      spDevelopmentBefore={spDevelopmentBefore}
      spDevelopmentAfterTop={spDevelopmentAfterTop}
      spDevelopmentAfterBottom={spDevelopmentAfterBottom}
      accordionOpen={accordionOpen}
      colorButtonAccordionTitle1={colorButtonAccordionTitle1}
      colorButtonAccordionTitle2={colorButtonAccordionTitle2}
      colorButtonHref={colorButtonHref}
      linkButtonAccordionTitle1={linkButtonAccordionTitle1}
      linkButtonAccordionTitle2={linkButtonAccordionTitle2}
      linkButtonHref={linkButtonHref}
      episodeClickHandler={episodeClickHandler}
    />
  )
}

export default ContentEpisodeRow
